export default __webpack_public_path__ + "/dist/images/invitations-active.32d678915207e4992612a1702b87f620.svg";